import { client } from '../client';

export const deleteUserAvailability = async (user_id: string, availability_id: string): Promise<void> => {
  const { data } = await client.delete(`/users/${user_id}/user_availability/${availability_id}`);

  return data;
};
